import { useCallback, useState } from 'react'
import dayjs from 'dayjs'
import { AgxButton, AgxDatePicker, AgxRow } from '@urbanx/agx.ui-components2'
import { SubPagePanel } from 'components/panel/SubPagePanel'

interface ConditionPanelProps {
  id: string
  panelTitle: string
  contractDate?: Date
  onChange: (contractDate: Date | undefined) => void
  isDocuSigned?: boolean
}

export function ContractDatePanel({
  id,
  panelTitle,
  contractDate,
  onChange,
  isDocuSigned = false,
}: ConditionPanelProps) {
  const [dueDate, setDueDate] = useState<Date | undefined>(contractDate)
  const [isEditingContractDate, setIsEditingContractDate] = useState(false)

  const onEditContractDate = useCallback(() => {
    if (isEditingContractDate) {
      onChange(dueDate)
      setIsEditingContractDate(false)
    } else {
      setIsEditingContractDate(true)
    }
  }, [isEditingContractDate, dueDate, onChange])

  return (
    <SubPagePanel
      key={`deposit-panel-${id}`}
      expandable
      panelTitle={panelTitle}
      defaultExpanded
    >
      <AgxRow
        gap="spacing-md"
        fill
        padding={{ top: 'spacing-md', bottom: 'spacing-3xl' }}
        alignItems="flex-end"
      >
        <AgxDatePicker
          id={`${id}-due-date`}
          stretch
          disabled={!isEditingContractDate || isDocuSigned}
          label="Date"
          value={dueDate ? dayjs(dueDate).format('YYYY-MM-DD') : ''}
          optionalText=""
          onChange={(value) => {
            setDueDate(value ? new Date(value) : undefined)
          }}
        />
        {!isDocuSigned && (
          <AgxButton
            id={`${id}-edit-due-date`}
            variant="hollow"
            text={isEditingContractDate ? 'Save' : 'Edit'}
            onClick={onEditContractDate}
          />
        )}
      </AgxRow>
    </SubPagePanel>
  )
}
